import { Box, Typography } from "@mui/material";

const sx = {
  root: (theme) => ({
    display: "flex",
    alignItems: "center",
    minHeight: 36,
    px: 1.5,
    py: 0.5,
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.custom.panelChrome,
  }),
  title: {
    fontSize: 13,
    fontWeight: 600,
    color: "text.primary",
    flex: 1,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
};

const PanelHeader = ({ title, titleContent, children }) => (
  <Box sx={sx.root}>
    {titleContent || <Typography sx={sx.title}>{title}</Typography>}
    {children && <Box sx={sx.actions}>{children}</Box>}
  </Box>
);

export default PanelHeader;
